// extracted by mini-css-extract-plugin
module.exports = {"container":"E1yUJ","zoomIn":"JSOgX","zoomOut":"gESJY"};